export default theme => ({
  root: {
    padding: theme.spacing.unit * 3,
    flexGrow: 1
  },
  content: {
    marginTop: theme.spacing.unit * 2
  },
  mapWrapper: {
    height: '30vh',
    minHeight: 200
  },
  progressWrapper: {
    paddingTop: '48px',
    paddingBottom: '48px',
    display: 'flex',
    justifyContent: 'center'
  },
  textWrapper: {
    paddingTop: '48px',
    paddingBottom: '48px',
    display: 'flex',
    justifyContent: 'center'
  }
});
